export default "__VITE_ASSET__6848fefd__"